import React from 'react';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import styled from '@emotion/styled';
import { useUserContext } from 'src/context/UserProvider';

const BorderLinearProgress = styled(LinearProgress)(({}) => ({
	height: 3.2,
	borderRadius: 5,
	[`&.${linearProgressClasses.colorPrimary}`]: {
		backgroundColor: '#D9D9D9',
	},
	[`& .${linearProgressClasses.bar}`]: {
		borderRadius: 5,
		backgroundColor: '#FFCC00',
	},
}));

const TrialPeriod = () => {
	const { user } = useUserContext();
	const trialStartDate = new Date('2024-08-18');
	const accountCreationDate = new Date(user?.createdAt || '');
	const today = new Date();

	// Check if the user's account was created after September 1, 2024
	if (accountCreationDate < trialStartDate) {
		return null; // Don't show the trial period for older accounts
	}

	const trialEndDate = new Date(accountCreationDate.getTime() + 90 * 24 * 60 * 60 * 1000);
	const daysLeft = Math.max(0, Math.ceil((trialEndDate.getTime() - today.getTime()) / (24 * 60 * 60 * 1000)));
	const progress = Math.min(100, ((90 - daysLeft) / 90) * 100);

	return (
		<div className="flex items-center border-[0.8px] border-[#7777E7] rounded-[3.2px] bg-[#EFF5FF] ">
			<div className="py-1 px-1 flex flex-col text-center">
				<p className="text-[#555770] text-[11.2px] md:text-[14.4px] font-[500] leading-[19.2px] md:leading-[24px]">
					Trial Period
				</p>
				<BorderLinearProgress variant="determinate" value={100 - progress} />
			</div>
			<div className="p-[1.6px]">
				<div className="flex flex-col p-[1.6px] bg-whtie items-center justify-between rounded-[1.6px] bg-white">
					<p className="text-[9.6px] md:text-[12.8px] font-[500] leading-[14.4px] md:leading-[19.2px] text-[#28293D]">
						{daysLeft}
					</p>
					<p className="text-[6.4px] md:text-[9.6px] font-[500] leading-[9.6px] md:leading-[14.4px] text-[#555770]">
						days left
					</p>
				</div>
			</div>
		</div>
	);
};

export default TrialPeriod;
